module.exports = __webpack_public_path__ + "static/demo-screen-1-f517b2f79a1d2253bb39888929eb5b59.jpg";